<template lang="html">
    <v-form ref="form">
        <v-container grid-list-xs>
            <v-layout wrap>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs12>
                            <v-form v-model="code_ok">
                                <v-text-field @input="onInput" label="Code article" v-model="product_code" required :color="color"
                                    :loading="loading" :error="error" :hint="message" :rules="rules.product_code">
                                </v-text-field>
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
export default {
    data() {
        return {
            title: 'Lier un produit Sidamo',
            icon: 'add_circle',
            isValid: false,
            code_ok: false,
            color: 'primary',
            error: false,
            message: null,
            loading: false,
            product_code: '',
            product_id: null,
            rules: {
                product_code: [
                    (v) => !!v && !isNaN(v) && v.length > 5 || 'Code de 6 chiffres obligatoire',
                ]
            },
        }
    },
    methods: {
        onInput() {
            const isValidLength = !!this.product_code && !isNaN(this.product_code) && this.product_code.length > 5;
    
            if (!isValidLength) {
                this.error = true;
                this.color = 'error';
                this.message = 'Code de 6 chiffres obligatoire';
                return;
            }

            this.checkCode(this.product_code);
        },
        checkCode(code) {
            this.loading = true
            this.axios.get('/api/products?filters=code|=|' + code)
                .then(response => {
                    if (response.data.length > 0) {
                        this.error = false
                        this.loading = false
                        this.product_id = response.data[0].id
                        if (response.data[0].project_id != null) {
                            if (response.data[0].project_id == this.$store.state.single.data.id) {
                                this.color = 'error'
                                this.message = 'Le produit ' + response.data[0].label + ' est déjà lié à ce projet'
                            } else {
                                this.color = 'warning'
                                this.message = 'Le produit ' + response.data[0].label + ' est déjà lié à un projet. Êtes vous sûre de vouloir modifier ce produit'
                            }
                        } else {
                            this.color = 'success'
                            this.message = ''
                        }
                    } else {
                        this.error = true
                        this.loading = false
                        this.color = 'error'
                        this.message = 'Ce produit n\'existe pas'
                    }

                })
        },
        onClose() {
            this.$eventHub.$emit('close-modal')
        },
        onValidate() {
            if (this.product_id != null) {
                this.axios.put(`/api/products/${this.product_id}`, { project_id: this.$store.state.single.data.id })
                    .then(response => {
                        this.$eventHub.$emit('reload-single-project');
                        this.onClose()
                    })
            } else {
                this.onClose()
            }
        }
    },
    mounted() {

    }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/projects/single/AddSidamoProduct.vue